// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html
import { INTEGRATION_MELI_IDENTIFIER } from 'cfgCommon/BFFUtils'
import Spinner from 'common/Spinner'
import React from 'react'
import { WithErrorBoundary } from '../common/ErrorBoundary'

const MainIntegrations = WithErrorBoundary(
  'integraciones',
  'Error en Integrations',
  React.lazy(() => import('./MainIntegrations')),
)

const ManageFormContainer = WithErrorBoundary(
  'integraciones',
  'Error en Formulario de Publicación',
  React.lazy(() => import('./manage-publish-form/ManageForm.container')),
)

const AddAccount = WithErrorBoundary(
  'integraciones',
  'Error en agregar cuenta',
  React.lazy(() => import('./AddAccount')),
)

const DisconnectAccount = WithErrorBoundary(
  'integraciones',
  'Error en desconectar cuenta',
  React.lazy(() => import('./DisconnectAccount')),
)

const MainIntegrationConfiguration = WithErrorBoundary(
  'integraciones',
  'Error en configuracion de integracion',
  React.lazy(() => import('./configuration/MainIntegrationConfiguration')),
)

const MainPageConfig = WithErrorBoundary(
  'integraciones',
  'Error en configuracion de páginas',
  React.lazy(() => import('./configuration/MainPageConfig')),
)

export default {
    path: '/integraciones',
    name: 'integraciones',
    childRoutes: [
        {
            path: 'canales-de-venta',
            name: 'integracionesCanalesDeVenta',
            component: MainIntegrations,
            isIndex: true
        },
        {
            path: `canales-de-venta/${INTEGRATION_MELI_IDENTIFIER}/:idIdentifier`,
            name: 'Procesando nuevo código...',
            component: Spinner
        },
        {
            path: 'canales-de-venta/:nameIntegration/:nameAccount/:idAccount',
            name: 'Formulario de publicación',
            component: ManageFormContainer
        },
        {
            path: 'canales-de-venta/agregar-cuenta',
            name: 'integracionesAgregarCuenta',
            component: AddAccount
        },
        {
          path: 'canales-de-venta/desconectar-cuenta',
          name: 'integracionesDesconectarCuenta',
          component: DisconnectAccount
        },
        {
          path: 'canales-de-venta/configuracion/:idPage',
          name: 'integracionesConfiguracion',
          component: MainIntegrationConfiguration
        },
        {
          path: 'canales-de-venta/configuracion/formulario/config/:idForm',
          name: 'integracionesConfiguracionPágina',
          component: MainPageConfig
        }
    ]
}